import React, { useState } from "react";
import { Input, Button, Form } from "antd";
import { MailOutlined, FileImageOutlined, SmileOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const PostComponent: React.FC = () => {
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        console.log("Submitted Values: ", values);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: 20 }}
        >
            <Form.Item
                label="Description"
                name="description"
                rules={[{ required: true, message: "Please enter details!" }]}
            >
                <TextArea rows={4} placeholder="Enter Announcement Details here" />
            </Form.Item>
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                <Button icon={<MailOutlined />} shape="circle" />
                <Button icon={<FileImageOutlined />} shape="circle" />
                <Button icon={<SmileOutlined />} shape="circle" />
            </div>
        </Form>
    );
};

export default PostComponent;
